import React, {useReducer} from "react";
import {initState, ProfileContext} from "./profileContext";
import {profileReducer} from "./profileReducer";
import {SET_PROFILE} from "../types";


// @ts-ignore
export const ProfileState = ({children}) => {

  const [state,dispatch]= useReducer(profileReducer, initState);

  const setProfile = (payload:string) => {
    dispatch({type:SET_PROFILE, payload})
  }

  return (
    // @ts-ignore
    <ProfileContext.Provider value={
      {
        // isAuth: state.isAuth,
        // title: state.title,
        profile: state.profile,
        setProfile
      }
    }>
      {children}
    </ProfileContext.Provider>
  )
}
